import { render, staticRenderFns } from "./RuleSelector.vue?vue&type=template&id=6811e1b5"
import script from "./RuleSelector.vue?vue&type=script&lang=js"
export * from "./RuleSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports